import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useT } from '../i18n';

const DataTable = ({ data, loading, compact = false }) => {
  const t = useT();
  const [currentPage, setCurrentPage] = useState(1);

  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full mx-auto"></div>
        <p className="text-sm text-muted-foreground mt-4">{t('table.loading')}</p>
      </div>
    );
  }

  if (!data || !data.data || data.data.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">{t('table.empty')}</p>
      </div>
    );
  }

  const { columns, data: rows, page, total_pages, total_rows } = data;

  return (
    <div className="space-y-4">
      <div className="overflow-x-auto rounded-[var(--radius)] border border-border">
        <table className="data-table" data-testid="data-table">
          <thead>
            <tr>
              {columns.map((col, idx) => (
                <th key={idx} className="whitespace-nowrap">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIdx) => (
              <tr key={rowIdx}>
                {columns.map((col, colIdx) => (
                  <td key={colIdx} className="whitespace-nowrap">
                    {row[col] !== null && row[col] !== undefined ? String(row[col]) : '-'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {!compact && (
        <div className="flex items-center justify-between text-sm">
          <div className="text-muted-foreground">
            {t('table.range', {
              from: (((page - 1) * 50) + 1).toLocaleString(),
              to: Math.min(page * 50, total_rows).toLocaleString(),
              total: total_rows.toLocaleString(),
            })}
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
              disabled={page === 1}
              className="btn-ghost h-8 w-8 p-0"
              data-testid="prev-page"
              aria-label={t('table.previousPage')}
            >
              <ChevronLeft className="h-4 w-4" />
            </button>
            <span className="text-sm">
              {t('table.page', { page, total: total_pages })}
            </span>
            <button
              onClick={() => setCurrentPage(Math.min(total_pages, currentPage + 1))}
              disabled={page === total_pages}
              className="btn-ghost h-8 w-8 p-0"
              data-testid="next-page"
              aria-label={t('table.nextPage')}
            >
              <ChevronRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataTable;